// extracted by mini-css-extract-plugin
export default {"btn":"noticeManagement_btn__tR0Yy","input":"noticeManagement_input__SLzro","icon":"noticeManagement_icon__JxMCW","box":"noticeManagement_box__Hs-+i"};